import React from 'react';

type Props = {
  width?: number;
  height?: number;
  color?: string;
};

const IconClipboardEdit: React.FC<Props> = ({
  width = 16,
  height = 16,
  color = '#3E454D',
}: Props) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.3334 2.83333H11.1534C11.0887 1.99733 10.5474 1.5 9.66675 1.5H6.33341C5.45275 1.5 4.91143 1.99733 4.84676 2.83333H4.66675C3.05475 2.83333 2.16675 3.72133 2.16675 5.33333V12C2.16675 13.612 3.05475 14.5 4.66675 14.5H11.3334C12.9454 14.5 13.8334 13.612 13.8334 12V5.33333C13.8334 3.72133 12.9454 2.83333 11.3334 2.83333ZM5.83341 3C5.83341 2.60733 5.94075 2.5 6.33341 2.5H9.66675C10.0594 2.5 10.1667 2.60733 10.1667 3V3.66667C10.1667 4.05933 10.0594 4.16667 9.66675 4.16667H6.33341C5.94075 4.16667 5.83341 4.05933 5.83341 3.66667V3ZM12.8334 12C12.8334 13.0513 12.3847 13.5 11.3334 13.5H4.66675C3.61541 13.5 3.16675 13.0513 3.16675 12V5.33333C3.16675 4.282 3.61541 3.83333 4.66675 3.83333H4.84676C4.91143 4.66933 5.45275 5.16667 6.33341 5.16667H9.66675C10.5474 5.16667 11.0887 4.66933 11.1534 3.83333H11.3334C12.3847 3.83333 12.8334 4.282 12.8334 5.33333V12ZM10.8468 7.14665L10.1868 6.48665C9.9801 6.27999 9.70613 6.16667 9.4148 6.16667C9.41413 6.16667 9.41349 6.16667 9.41349 6.16667C9.12149 6.16667 8.84604 6.28131 8.64071 6.48865L4.98006 10.166C4.88606 10.2593 4.83407 10.3867 4.83407 10.5187V12C4.83407 12.276 5.05807 12.5 5.33407 12.5H6.81616C6.94816 12.5 7.07537 12.4473 7.1687 12.354L10.8461 8.69332C11.0534 8.48732 11.1667 8.21265 11.1674 7.92065C11.1674 7.62865 11.0534 7.35398 10.8468 7.14665ZM9.41414 7.16667C9.43148 7.16667 9.45674 7.17134 9.47941 7.19401L10.1394 7.854C10.1621 7.87667 10.1667 7.90267 10.1667 7.92C10.1667 7.93734 10.1621 7.96269 10.1394 7.98535L9.71541 8.40735L8.92603 7.618L9.34806 7.19401C9.3714 7.17134 9.39681 7.16667 9.41414 7.16667ZM6.60881 11.5H5.83341V10.7247L8.22078 8.32666L9.00675 9.11267L6.60881 11.5Z"
      fill={color}
    />
  </svg>
);

export default IconClipboardEdit;
